// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","root":"BotHeadSpin_root__JenPF","rotate":"BotHeadSpin_rotate__aKfQf","inPanel":"BotHeadSpin_inPanel__6YDzI"};